import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);

  const handleRegister = async () => {
    setError("");

    if (!email || !password || !phone) {
      setError("همه فیلدها الزامی هستند");
      return;
    }

    try {
      const response = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, phone }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem("loggedIn", "true");
        window.location.reload();
      } else {
        setError(data.message || "ثبت‌نام ناموفق بود");
      }
    } catch (err) {
      setError("خطا در ارتباط با سرور");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("ایمیل و رمز عبور را وارد کنید");
      return;
    }

    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem("loggedIn", "true");
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        localStorage.setItem('name', data.name);
        const res = await fetch("/api/chat/new_session", {
          method: "POST"
        });
        const session_id = await res.json();

        localStorage.setItem("session_id", session_id.session_id)
        localStorage.setItem("welcomeShown" , false)
        window.location.reload();
      } else {
        setError(data.message || "ورود ناموفق بود");
      }
    } catch (err) {
      setError("خطای سرور! دوباره تلاش کنید");
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const res = await fetch("/api/auth/login/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });
      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        localStorage.setItem('name', data.name);
        localStorage.setItem("loggedIn", "true");
        const res = await fetch("/api/chat/new_session", {
          method: "POST"
        });
        const session_id = await res.json();

        localStorage.setItem("session_id", session_id.session_id)
        localStorage.setItem("welcomeShown" , false)

        window.location.reload();
      } else {
        setError(data.error || "مشکل در لاگین با گوگل");
      }
    } catch (err) {
      setError("مشکل در ارتباط با سرور");
    }
  };

  const handleGoogleError = () => {
    setError("لاگین با گوگل لغو شد یا با خطا مواجه شد.");
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "100px auto",
        padding: 20,
        border: "1px solid #eee",
        borderRadius: 12,
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
        fontFamily: "Vazir, sans-serif",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: 20 }}>
        {isRegistering ? "ثبت‌نام" : "ورود"}
      </h2>

      <form onSubmit={isRegistering ? (e) => { e.preventDefault(); handleRegister(); } : handleLogin}>
        {isRegistering && (
          <div>
            <label>شماره تلفن:</label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={{ width: "100%", marginBottom: 12 }}
            />
          </div>
        )}

        <div>
          <label>ایمیل:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", marginBottom: 12 }}
          />
        </div>

        <div>
          <label>رمز عبور:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", marginBottom: 12 }}
          />
        </div>

        {error && (
          <div style={{ color: "red", marginBottom: 12, textAlign: "center" }}>
            {error}
          </div>
        )}

        <button type="submit" style={{ width: "100%", marginBottom: 12 }}>
          {isRegistering ? "ثبت‌نام" : "ورود"}
        </button>
      </form>

      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        width="100%"
        text="signin_with"
      />

      <p style={{ textAlign: "center", marginTop: 16 }}>
        {isRegistering ? "حساب داری؟" : "حساب نداری؟"}{" "}
        <span
          onClick={() => setIsRegistering(!isRegistering)}
          style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
        >
          {isRegistering ? "ورود" : "ایجاد حساب"}
        </span>
      </p>
    </div>
  );
}

export default Login;
